export const bestPracticeDemoList = [
  {
    alias: '1',
    cover: 'https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/best-company/1.png',
    name: '互联网软件行业',
    profile:
      '从获客到成交全链路在线管理，帮助企业沉淀客户资，减少客户流失与过程断点，让增长动作可追踪、销售结果可复盘、团队经验可复制。'
  }
  /**
  {
    alias: 'medicalDevice',
    cover:
      'https://cdn.xbongbong.com/digitalHubTest/proadminpng/f99ce1f6ac88d68b753954df6c06026ec3db6fd76643d58f660cd4bf451178a5.png',

    name: '医疗器械行业',
    profile: '同步线下拜访轨迹，完整记录客户沟通'
  },
  {
    alias: 'newEnergy',
    cover:
      'https://image-resource.mastergo.com/93344528149904/98128776139893/c4899db2f81d6ab88521fa61f10fe620.jpg',
    icon: 'https://xbongbong.oss-cn-hangzhou.aliyuncs.com/cdnfile/jczx/jczx-1.svg',
    name: '新能源行业',
    profile: '同步线下拜访轨迹，完整记录客户沟通'
  },
  {
    alias: 'chemicalMaterials',
    cover:
      'https://image-resource.mastergo.com/93344528149904/98128776139893/c6e3855c2e3f0d2689a8579ad96f387a.jpg',
    icon: 'https://xbongbong.oss-cn-hangzhou.aliyuncs.com/cdnfile/jczx/jczx-1.svg',
    name: '化工新材料行业',
    profile: '同步线下拜访轨迹，完整记录客户沟通全流程，同步线下拜访轨迹，完整记录客户沟通全流程'
  },
  {
    alias: 'foodBeverage',
    cover:
      'https://image-resource.mastergo.com/93344528149904/98128776139893/f4e6e53e8172113e13254f4cb0bd6286.jpg',
    icon: 'https://xbongbong.oss-cn-hangzhou.aliyuncs.com/cdnfile/jczx/jczx-1.svg',
    name: '食品饮料行业',
    profile: '同步线下拜访轨迹，完整记录客户沟通'
  },
  {
    alias: 'enterpriseService',
    cover:
      'https://image-resource.mastergo.com/93344528149904/98128776139893/1b39d162aa00b7446df6dfa9e5841676.jpg',
    icon: 'https://xbongbong.oss-cn-hangzhou.aliyuncs.com/cdnfile/jczx/jczx-1.svg',
    name: '企业服务行业',
    profile: '同步线下拜访轨迹，完整记录客户沟通'
  } */
]
